<div class="card p-0 h-100">
	<div class="d-flex">
		<div class="h3 mx-4 mt-2 mb-1">Invoices, Services & Contracts</div>
	</div>
	<p-divider></p-divider>
	<p-tabView>
		<p-tabPanel headerStyleClass="p-tab-header" *ngIf="venueService.venueFinance.value.invoices?.length > 0">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'file-invoice-dollar']" class="me-4" size="lg"></fa-icon>
				Invoices
			</ng-template>
			<app-invoice-dashboard></app-invoice-dashboard>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header" *ngIf="venueService.venueFinance.value.subscriptions?.length > 0">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'atom-alt']" class="me-4" size="lg"></fa-icon>
				Services
			</ng-template>
			<app-service-subscription-dashboard></app-service-subscription-dashboard>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header" *ngIf="venueService.venueFinance.value.contracts?.length > 0">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'file-signature']" class="me-4" size="lg"></fa-icon>
				Contracts
			</ng-template>
			<app-contract-dashboard></app-contract-dashboard>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header" *ngIf="venueService.venueFinance.value.paymentProfiles?.length > 0">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'money-check-dollar']" class="me-4" size="lg"></fa-icon>
				Payment Profiles
			</ng-template>
			<app-contract-finance-payment-profile-list></app-contract-finance-payment-profile-list>
		</p-tabPanel>
	</p-tabView>
</div>
